import {useNavigate} from 'react-router-dom';
import {CardPlan} from '@tinct/web-components';
import {useCurrentOrganization, useCurrentWorkspaceUrlPrefix, useGetCurrentQuotas} from '@tinct/core-workspace';
import type {ReadQuota} from '@tinct/core-api-models';

/** Share of a quota already consumed, in whole percents (0 when the quota is unlimited / unknown). */
const usedPercent = (quota?: ReadQuota) => {
  const limit = quota?.quotaLimit ?? 0;
  if (!limit) return 0;
  return Math.floor(((limit - (quota?.remainingQuota ?? 0)) / limit) * 100);
};

/**
 * Sidebar plan card of an agency workspace. Besides the `workspace_count`
 * seat pool, an agency also holds the generation / publication credits it
 * distributes to its client workspaces, so those are shown alongside.
 */
export const AgencySeatsCard = () => {
  const navigate = useNavigate();
  const workspaceUrlPrefix = useCurrentWorkspaceUrlPrefix();
  const organization = useCurrentOrganization();
  const {quotas, lpGenerationQuota: credits, lpPublicationQuota: publications} = useGetCurrentQuotas();
  const seats = quotas?.find((q) => q.featureKey === 'workspace_count');


  return (
    <CardPlan
      className="group-data-[collapsible=icon]:hidden"
      variant={organization.subscription !== null ? 'paid' : 'free'}
      title="Agency plan"
      buttonText="Manage billing"
      onAction={() => navigate(`${workspaceUrlPrefix}/settings/billing`)}
      usageStats={[
        {
          label: 'workspaces left',
          value: seats?.remainingQuota ?? 0,
          percent: usedPercent(seats),
        },
        {
          label: 'credits left',
          value: credits?.remainingQuota ?? 0,
          percent: usedPercent(credits),
        },
        {
          label: 'page variants left',
          value: publications?.remainingQuota ?? 0,
          percent: usedPercent(publications),
        },
      ]}
    />
  );
};
